import { useEffect } from 'react';

import { fDateTime } from 'src/utils/format-time';

import { Label } from 'src/components/label';
import { toast } from 'src/components/snackbar';

export const hasPermission = (user, permission) =>
  user?.activeContext?.permissions?.includes(permission) ?? false;

export const errorMessage = (error) => error?.message || 'عملیات انجام نشد.';

export function QueryError({ error }) {
  useEffect(() => {
    if (error) {
      const message = errorMessage(error);
      toast.error(message, { id: `query-error-${message}` });
    }
  }, [error]);

  return null;
}

const colors = {
  Active: 'success',
  Accepted: 'success',
  Pending: 'warning',
  PendingVerification: 'warning',
  Invited: 'info',
  Suspended: 'error',
  Locked: 'error',
  Expired: 'default',
  Cancelled: 'default',
  Revoked: 'error',
  Left: 'default',
};

const labels = {
  Active: 'فعال',
  Accepted: 'پذیرفته',
  Pending: 'در انتظار',
  PendingVerification: 'در انتظار تأیید',
  Invited: 'دعوت‌شده',
  Suspended: 'تعلیق‌شده',
  Locked: 'قفل‌شده',
  Expired: 'منقضی',
  Cancelled: 'لغوشده',
  Revoked: 'باطل‌شده',
  Left: 'خارج‌شده',
  Succeeded: 'موفق',
  Failed: 'ناموفق',
};

export function StatusLabel({ value }) {
  return (
    <Label color={colors[value] || (value === 'Failed' ? 'error' : 'default')}>
      {labels[value] || 'نامشخص'}
    </Label>
  );
}

export const formatDateTime = (value) => (value ? fDateTime(value) : '—');
